import { render } from "./SelectedPatientPatch.vue?vue&type=template&id=d0dc53c2&scoped=true"
import script from "./SelectedPatientPatch.vue?vue&type=script&lang=js"
export * from "./SelectedPatientPatch.vue?vue&type=script&lang=js"

import "./SelectedPatientPatch.vue?vue&type=style&index=0&id=d0dc53c2&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0dc53c2"]])

export default __exports__